/**
 * Constants for Context IDs feature
 */

export enum TenantProductCode {
  EDGE = 'Edge',
  XMCLOUD = 'XMCloud',
}

// UI Text Constants
export const CONTEXT_IDS_TEXT = {
  SENSITIVE_RESOURCE_TOOLTIP:
    'This resource can provide access to sensitive data. For security, keep the associated Context ID private.',
  NO_CONTEXT_IDS_FOUND:
    'No context IDs found. Try adjusting your search or resource filters.',
  NO_CONTEXT_IDS_CREATED:
    'No context IDs created. Add your first context ID for your organization.',
  SEARCH_PLACEHOLDER: 'Search',
  CLEAR_SEARCH: 'Clear search',
  RESOURCE_FILTER_PLACEHOLDER: 'Resource',
  NO_RESOURCES_AVAILABLE: 'No resources available',
  RESOURCE_LABEL: 'Resource: ',
  SENSITIVE_RESOURCE_WARNING: 'Sensitive resource warning',
  RESOURCES_TEXT: 'resources',
  RESOURCES_HEADER: 'Resources',
  TENANTS_HEADER: 'Environments',
  TENANT_HEADER: 'Environment',
  LIVE_STATUS: 'live',
  PREVIEW_STATUS: 'preview',
  EDIT_ACTION: 'Edit',
  DELETE_ACTION: 'Delete',
  SCOPED_CONTEXT_ID_COLUMN: 'Scoped Context ID',
  SCOPED_CONTEXT_NAME_COLUMN: 'Scoped Context ID name',
  RESOURCES_APPLIED_COLUMN: 'Resources applied',
  VIEW_DETAILS_ACTION: 'View details',
  REGENERATE_ACTION: 'Regenerate',
  CONTEXT_ID_COLUMN: 'Context ID',
  NAME_COLUMN: 'Name',
  DESCRIPTION_COLUMN: 'Description',
  UPDATED_AT_COLUMN: 'Updated at',
  NO_RESOURCES_ADDED: 'No resources added.',
  MASTER_TAG: 'Master',
  ADD_SEARCH_RESOURCE_TITLE: 'Add Search resource',
  ADD_SEARCH_RESOURCE_DOMAIN_ID_LABEL: 'Domain ID',
  ADD_SEARCH_RESOURCE_REGION_LABEL: 'Region',
  ADD_SEARCH_RESOURCE_API_KEY_LABEL: 'API key',
  ADD_SEARCH_RESOURCE_TENANT_LABEL: 'Search environment',
  ADD_SEARCH_RESOURCE_DOMAIN_ID_TOOLTIP:
    'Can be obtained by clicking on your environment name in Sitecore Search, in the upper right corner.',
  ADD_SEARCH_RESOURCE_REGION_TOOLTIP:
    'Can be obtained by clicking on your environment name in Sitecore Search, in the upper right corner.',
  ADD_SEARCH_RESOURCE_API_KEY_TOOLTIP:
    'Can be created in the Developer Resources area.',
  ADD_SEARCH_RESOURCE_API_KEY_DOCS_LINK_TEXT:
    'API authentication and authorization',
  ADD_SEARCH_RESOURCE_API_KEY_DOCS_PREFIX: 'For details see here:',
  SAVE_DISABLED_TOOLTIP: 'Assign an environment to at least one resource to continue',
} as const;

export const SEARCH_PRODUCT_CODE = 'Search';
export const SEARCH_RESOURCE_TYPE = 'search';
export const SEARCH_RESOURCE_NAME = 'Sitecore Search';
